import styled from 'styled-components';

export const Wrapper = styled.div<{ $fullWidth?: boolean }>`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '348px')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }

  &:hover {
    background-color: white;
  }

  img {
    opacity: 0.8;
  }
`;
